<template>
	<div>
		<v-table>
			<thead>
				<tr>
					<th>Username</th>
					<th>E-Mail</th>
					<th>Firstname</th>
					<th>Lastname</th>
					<th>Base</th>
					<th>Delete</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="item in user">
					<td>{{ item.username }}</td>
					<td>{{ item.email }}</td>
					<td>{{ item.firstname }}</td>
					<td>{{ item.lastname }}</td>
					<td>{{ item.baseAirport.airport_codename }}</td>
					<td>
						<v-btn
							:loading="loading[item._id]"
							:disabled="loading[item._id]"
							size="x-small"
							color="red"
							icon="mdi-delete"
							@click="deleteUser(item._id)"
						></v-btn>
					</td>
				</tr>
			</tbody>
		</v-table>
	</div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
	computed: {
		...mapState({
			token: "token",
		}),
	},
	data() {
		return {
			user: "",
			clicked: "",
			loading: [],
		};
	},
	mounted() {
		axios
			.get(process.env.VUE_APP_BACKEND_URL + "/auth/user", {
				headers: {
					Authorization: "bearer " + this.token,
				},
			})
			.then((response) => {
				this.user = response.data;
				console.log(response.data);
			})
			.catch((e) => {
				console.error(e);
			});
	},
	methods: {
		deleteUser(id) {
			this.loading[id] = true;

			axios
				.delete(process.env.VUE_APP_BACKEND_URL + "/auth/user/" + id, {
					headers: {
						Authorization: "bearer " + this.token,
					},
				})
				.then(() => {
					const objIndex = this.user.findIndex((item) => item._id === id);
					this.user.splice(objIndex, 1);
					this.loading[id] = false;
				})
				.catch((e) => {});
		},
	},
};
</script>

<style></style>
